//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import TrackAnalysis from "@/components/Track/TrackAnalysis";
import TrackInfo from "@/components/Track/TrackInfo";
import TrackControl from "@/components/Track/TrackControl";
import TrackList from "@/components/Track/TrackList";
import ArtistInfo from "@/components/Artist/ArtistInfo";
import { mapMutations } from "vuex";
import { GetTokenInfo } from "@/services/auth";
export default {
  components: {
    TrackAnalysis,
    TrackInfo,
    TrackControl,
    TrackList,
    ArtistInfo
  },
  data() {
    return {
      poller: null,
      sessionExpired: false,
      accessToken: null,
      currentTrack: null,
      currentTrackFeatures: null,
      currentAlbumTracks: [],
      currentArtist: null,
      currentArtistPopularTracks: [],
      genius: {
        searchResults: [],
        song: null,
        artist: null
      }
    };
  },
  methods: {
    ...mapMutations(["setCurrentTrackId"]),

    getCurrentTrack() {
      axios
        .get("https://api.spotify.com/v1/me/player/currently-playing", {
          headers: { authorization: `Bearer ${this.accessToken}` }
        })
        .then(response => {
          if (response.status === 204) {
            return;
          }
          if (response.data.currently_playing_type === "track") {
            this.currentTrack = response.data;
            if (this.currentTrack.item.id != this.$store.state.currentTrackId) {
              this.getAdditionalTrackInformation(this.currentTrack);
            }
            this.setCurrentTrackId(this.currentTrack.item.id);
          } else {
            this.currentTrack = null;
            this.genius.song = null;
            this.setCurrentTrackId(null);
          }
        })
        .catch(() => {});
    },
    getAdditionalTrackInformation(spotifyTrack) {
      this.getAudioFeaturesForTrack(spotifyTrack.item.id);
      this.getTracksOnAlbum(spotifyTrack.item.album.id);
      this.geniusSearch(spotifyTrack.item);
    },

    geniusSearch(track) {
      var q = `${track.name} ${track.artists[0].name}`;
      axios
        .get(
          `${
            process.env.VUE_APP_FIREBASE_FUNCTIONS_BASE
          }/searchGenius?q=${encodeURIComponent(q)}`
        )
        .then(response => {
          this.genius.searchResults = response.data.response.hits;
          if (this.genius.searchResults && this.genius.searchResults.length) {
            var exactMatch = this.genius.searchResults.find(x => {
              let sanitizedGeniusName = this.sanitizeString(
                x.result.primary_artist.name
              );
              let sanitizedSpotifyName = this.sanitizeString(
                track.artists[0].name
              );
              return sanitizedGeniusName === sanitizedSpotifyName;
            });
            if (exactMatch) {
              this.getGeniusSongInfo(exactMatch.result.id);
            } else {
              this.genius.song = null;
              this.genius.artist = null;
            }
          } else {
            this.genius.song = null;
            this.genius.artist = null;
          }
        });
    },
    getGeniusSongInfo(geniusSongId) {
      axios
        .get(
          `${process.env.VUE_APP_FIREBASE_FUNCTIONS_BASE}/song?id=${geniusSongId}`
        )
        .then(response => {
          this.genius.song = response.data.response.song;
        });
    },
    getTracksOnAlbum(albumId) {
      axios
        .get(`https://api.spotify.com/v1/albums/${albumId}/tracks`, {
          headers: { authorization: `Bearer ${this.accessToken}` }
        })
        .then(response => {
          this.currentAlbumTracks = response.data.items;
        })
        .catch(() => {});
    },
    getAudioFeaturesForTrack(trackId) {
      axios
        .get(`https://api.spotify.com/v1/audio-features/${trackId}`, {
          headers: { authorization: `Bearer ${this.accessToken}` }
        })
        .then(response => {
          this.currentTrackFeatures = response.data;
        })
        .catch(() => {});
    },
    sanitizeString(inputString) {
      return inputString.toLowerCase().replace(/[\u200B-\u200D\uFEFF]/g, "");
    },
    reload() {
      location.reload();
    }
  },
  created() {
    this.currentTrack = null;
    this.setCurrentTrackId(null);
    GetTokenInfo().then(token => {
      this.accessToken = token.accessToken;
      this.getCurrentTrack();
    });

    let pollExpiration = new Date();
    pollExpiration.setHours(pollExpiration.getHours() + 1);

    this.poller = setInterval(() => {
      GetTokenInfo().then(token => {
        this.accessToken = token.accessToken;
        this.getCurrentTrack();
        if (new Date() > pollExpiration) {
          clearInterval(this.poller);
          this.sessionExpired = true;
        }
      });
    }, 5000);
  }
};
